.bid {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: var(--zumpo-space-8);
  padding: var(--zumpo-space-6) var(--zumpo-space-6) var(--zumpo-space-6)
    var(--zumpo-space-16);
  border: 1px solid var(--zumpo-line);
  border-radius: var(--zumpo-radius-999);
  background: var(--zumpo-cream);
  color: var(--zumpo-ink);
}

/* Figma counts the stroke in the size, so the latest bid is 2px larger. */
.latest {
  border: 2px solid var(--zumpo-ink);
  background: var(--zumpo-paper);
}

.name,
.times {
  color: var(--zumpo-muted);
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
  white-space: nowrap;
}

.latest .name {
  color: var(--zumpo-ink);
}

.count {
  font: var(--zumpo-text-number);
  letter-spacing: var(--zumpo-text-number-tracking);
}
